<template>
  <div class="page">
    <DirectoryBreadcrumbs />
    <RegistryTypeTable />
  </div>
</template>

<script>
import DirectoryBreadcrumbs from '@/components/directory/DirectoryBreadcrumbs';
import RegistryTypeTable from '@/components/directory/registryTypes/RegistryTypesTable';

export default {
  components: {
    DirectoryBreadcrumbs, RegistryTypeTable,
  },
};
</script>
